import { bnb } from '@0xtorch/core'
import { opBNB } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import { createNodeRealExplorer } from '../../explorer/nodeReal'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createOpBnbChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createOpBnbChainCustom({
    client: createClient({
      chain: opBNB,
      httpRpcs: opBnbHttpRpcs,
    }),
    explorer: createNodeRealExplorer({
      proxyUrl,
      fallback: createEtherscanV2({
        name: 'opBNB Mainnet Explorer',
        baseUrl: 'https://opbnb.bscscan.com',
        chainId: 204,
        apiKey,
        proxyUrl,
        pageSize,
      }),
    }),
  })

type CreateOpBnbParameters = {
  client: Client
  explorer: Explorer
}

export const createOpBnbChainCustom = ({
  client,
  explorer,
}: CreateOpBnbParameters): Chain => ({
  id: 204,
  network: 'op-bnb',
  name: 'opBNB',
  nativeToken: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18,
    currency: bnb,
  },
  wrappedTokenAddresses: new Set([
    '0x4200000000000000000000000000000000000006',
  ]),
  explorer,
  client,
  blockTime: 1000,
  coingeckoId: 'opbnb',
  defillamaId: undefined,
})

export const opBnbHttpRpcs: HttpRpc[] = [
  {
    url: 'https://opbnb-mainnet-rpc.bnbchain.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://opbnb.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://opbnb-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://1rpc.io/opbnb',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://opbnb.api.pocket.network',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://opbnb-mainnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://opbnb.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const opBnbWebsocketRpcUrls: readonly string[] = [
  'wss://opbnb.drpc.org',
  'wss://opbnb-rpc.publicnode.com',
  'wss://opbnb-mainnet.4everland.org/ws/v1/37fa9972c1b1cd5fab542c7bdd4cde2f',
]
